<template>
    <Modals/>
    <router-view/>
</template>

<script>
import Modals from "@/components/Modals.vue"
export default {
    components: {
        Modals
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
* {
    margin: 0;
    font-family: 'Open Sans', sans-serif;
    color: #333333;
}
input {
    height: 48px;
    outline: none;
    padding: 16px 14px;
    box-sizing: border-box;
    font-size: 16px;
    border: 1px solid #CDCDCD;
}
input[type="checkbox"] {
    width: 28px;
    height: 28px;
    filter: grayscale(100%) contrast(200%);
    box-sizing: border-box;
}
button {
    outline: none;
    border-radius: 0;
    background: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 64px;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #F9F9F9;
    cursor: pointer;
    border: 0;
}
.logo {
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    width: 134px;
    height: 45px;
    border: 1px solid #CDCDCD;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    margin-bottom: 40px;
}
</style>
